import { throwError } from 'rxjs';
import { MessageService } from 'primeng/api';

import { inject, Service } from '@angular/core';
import { type HttpErrorResponse } from '@angular/common/http';

@Service()
export class ToastService {
  private messageService: MessageService = inject(MessageService);

  info(message: string) {
    this.messageService.add({
      severity: 'info',
      detail: message,
    });
  }

  success(message: string) {
    this.messageService.add({
      severity: 'success',
      detail: message,
    });
  }

  error(message: string) {
    this.messageService.add({
      severity: 'error',
      detail: message,
    });
  }

  readonly httpError = (error: HttpErrorResponse) => {
    if (typeof error.error === 'string') {
      this.error(error.error);
      return throwError(() => error);
    }
    const content = error.error?.payload?.content as Record<string, string[]> | undefined;
    if (content) {
      Object.values(content)
        .flat()
        .forEach((message: string) => this.error(message));

      return throwError(() => error);
    }
    this.error(error.error?.message || error.message);
    return throwError(() => error);
  };
}
